import React from 'react';
import { Helmet } from 'react-helmet-async';

// Origin used in canonical/OG tags. Prefer explicit env var, fall back to the
// current window origin at runtime, then to a safe default.
function getPublicOrigin() {
  const envOrigin = process.env.REACT_APP_PUBLIC_URL;
  if (envOrigin) return envOrigin.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Lightweight SEO helper — inject <title>, description, canonical + OG/Twitter tags.
 */
export default function SEO({
  title,
  description,
  image,
  path = '',
  noindex = false,
  keywords,
  jsonLd,
}) {
  const origin = getPublicOrigin();
  const fullTitle = title || 'Russian Education — MBBS in Russia';
  const desc = description || 'Direct MBBS admission in NMC-approved Russian medical universities. 100% English medium, WHO-recognised, affordable fees, end-to-end guidance.';
  const url = `${origin}${path || ''}`;
  const ogImage = image || `${origin}/logo.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {origin && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      {origin && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content="Russian Education" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

